module.exports = __webpack_public_path__ + "static/file-mess-484a295f0c357f12ec2a1a17c42c2b35.png";